import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from '@fluentui/react-components';
import {
  Dismiss20Filled,
  Dismiss20Regular,
  bundleIcon,
} from '@fluentui/react-icons';
import type { ReactNode } from 'react';

import { useStyles } from './VersionReviewDialog.style.js';

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
const DismissIcon = bundleIcon(Dismiss20Filled, Dismiss20Regular);
/* eslint-enable @typescript-eslint/no-unsafe-assignment */

export interface VersionReviewDialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
}

export function VersionReviewDialog({
  open,
  title,
  onClose,
  children,
}: VersionReviewDialogProps) {
  const styles = useStyles();

  return (
    <Dialog
      open={open}
      onOpenChange={(_event, data) => {
        if (!data.open) onClose();
      }}
    >
      <DialogSurface className={styles.surface}>
        <DialogBody>
          <DialogTitle
            action={
              <DialogTrigger action="close">
                <Button
                  appearance="subtle"
                  icon={<DismissIcon />}
                  aria-label="Close"
                />
              </DialogTrigger>
            }
          >
            {title}
          </DialogTitle>
          <DialogContent className={styles.body}>{children}</DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={onClose}>
              Close
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
